import store from './store'

// 输出模块
export default store



// WEBPACK FOOTER //
// ./src/store/index.js